module.exports = __webpack_public_path__ + "static/media/hojadeplata_harinadetrigo(1).17508c7e.png";